import { UnknownAction } from '@reduxjs/toolkit';

import { resourceUpserters } from '../core';

import { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import * as actions from './userInfoActions';
import { USERINFO_REDUCER_KEY, UserInfoProps, mkUserInfoStore } from './userInfoTypes';

function reducer(
  state: QcsSyncResourceStore<UserInfoProps> = mkUserInfoStore(),
  action: UnknownAction,
): QcsSyncResourceStore<UserInfoProps> {
  switch (true) {
    case actions.getUserInfo.match(action):
      return state.set('isLoading', true);
    case actions.getUserInfoSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getUserInfoFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);

    case actions.setAlwaysMFA.match(action):
      return state.set('isLoading', true);
    case actions.setAlwaysMFASuccess.match(action):
      return resourceUpserters.upsertResource(state, action.payload);
    case actions.setAlwaysMFAFailure.match(action):
      return resourceUpserters.resetResources(state, action.payload);
    default:
      return state;
  }
}

export const REDUCER_KEY = USERINFO_REDUCER_KEY;
export default reducer;
